export default {
  reservations: 'Rezervări',
  activated: 'Activat',
  deactivated: 'Dezactivat',
  reservations_deactivated: 'Rezervările sunt dezactivate.',
  tabs: {
    general: 'General',
    information: 'Informații',
  },
  sections: {
    notifications_confirmation: 'Notificări și confirmare',
    notifications_confirmation_description: 'Cum rezervă oaspeții și cum ești notificat.',
    who_can_book: 'Cine poate rezerva',
    who_can_book_description: 'Limite de grup pentru rezervările online.',
    when_how_bookings_work: 'Când și cum funcționează rezervările',
    when_how_bookings_work_description:
      'Reguli de timp, durată și capacitate care determină sloturile vizibile pentru oaspeți.',
  },
  google: {
    label: 'Afișează rezervările pe Google',
  },
  storefront: {
    label: 'Afișează rezervările pe pagina restaurantului',
  },
  auto_confirm: {
    label: 'Confirmați automat rezervările',
  },
  email: {
    label: 'E-mail pentru rezervări primite',
    add: 'Adaugă e-mail',
    placeholder: 'Introduceți e-mailul',
    required: 'Adaugă cel puțin o adresă de e-mail pentru a primi rezervările noi.',
    invalid: 'Introdu o adresă de e-mail validă.',
  },
  has_whatsapp_phone_number: {
    label: 'Trimite notificări prin WhatsApp',
  },
  whatsapp_phone_number: {
    label: 'Număr WhatsApp',
    add: 'Adaugă număr de telefon',
  },
  party_size: {
    label: 'Dimensiunea grupului permis per rezervare',
    min_label: 'Min',
    max_label: 'Max',
    to: 'la',
    guests: 'persoane',
    helper:
      'Cât de mic sau mare poate fi un grup. Un oaspete poate rezerva doar pentru un număr de persoane în acest interval.',
    warning:
      'Google acceptă rezervări doar pentru 2–16 persoane. Rezervările în afara acestui interval vor funcționa pe pagina restaurantului, dar nu vor apărea pe Google.',
    warning_min: 'Google recomandă minimum 2 persoane pentru rezervări.',
    warning_max: 'Google recomandă maximum 16 persoane pentru rezervări.',
    min_note: 'Google nu va oferi rezervări pentru grupuri mai mici de {{count}}.',
  },
  time_slot: {
    label: 'Interval de rezervare',
    helper: 'Oaspeții pot rezerva din câte atâtea minute.',
    extra: 'ex. {{example}}',
  },
  reservation_gap: {
    label: 'Limită de rezervare înainte de închidere',
    helper: 'Ultima oră la care un oaspete poate face o rezervare, calculată înapoi față de ora de închidere.',
    helper_link: 'Vizualizați orele de rezervare',
    extra: 'ex. închideți la 22:00, limită {{example}} min → ultimul start posibil este {{example}}',
  },
  reservation_notice_period: {
    label: 'Preaviz minim',
    helper: 'Cel mai devreme cu cât un oaspete poate rezerva înainte de ora sosirii.',
    extra: 'ex. rezervați până la {{example}} pentru o sosire la 18:00',
  },
  opening_times: {
    label: 'Program de funcționare',
  },
  total_seats: {
    label: 'Capacitate totală de oaspeți',
    helper:
      'Numărul maxim de oaspeți (nu mese) care pot fi așezați simultan. Numărați locurile individuale — ex. 5 mese de 4 = 20.',
  },
  capacity_explainer: {
    title: 'Cum funcționează capacitatea',
    body: 'Acesta este numărul de oaspeți pe care îi puteți găzdui simultan. Fiecare rezervare ocupă locurile pe durata sa, apoi le eliberează pentru următorii oaspeți. Sistemul menține suficient spațiu pentru toți cei rezervați, astfel încât să nu fiți niciodată suprarezervat.',
    body_example:
      'Exemplu: cu 20 de locuri, puteți accepta o rezervare de 12 persoane la 19:00 și una de 10 persoane la 21:00, deoarece locurile primului grup se eliberează înainte de sosirea următorului.',
  },
  note: {
    label: 'Notă',
  },
  grace_period: {
    label: 'Perioadă de grație',
    helper: 'Cât timp să păstrați o masă după ora de start a rezervării.',
    tooltip:
      'Timp suplimentar adăugat după durata rezervării înainte ca masa să fie oferită din nou (ex. pentru curățare și pregătire).',
    extra: 'ex. rezervată până la {{example}} pentru o rezervare la 18:00',
    placeholder: 'Introduceți perioada de grație',
  },
  information: {
    rules: {
      label: 'Masa dumneavoastră va fi rezervată pentru:',
      add: 'Adaugă',
    },
  },
  reservation_duration: {
    label: 'Durata rezervării',
    helper: 'Cât timp este rezervată fiecare masă per rezervare.',
    tooltip:
      'Cât timp este rezervată o masă pentru fiecare rezervare. Aceasta este folosită pentru a determina când masa devine din nou disponibilă pentru următorul oaspete.',
    extra: 'ex. 18:00 – {{example}}',
    minutes: '{{ count }} Minute',
    hour_one: '{{ count }} Oră',
    hour_few: '{{ count }} ore',
    hour_other: '{{ count }} Ore',
  },
  buttons: {
    save: 'Salvează',
    activate: 'Activează',
    deactivate: 'Dezactivează',
  },
  success_messages: {
    updated: 'Actualizare reușită',
    saving_successful:
      'Actualizare reușită. Rețineți că Google poate dura până la 24 de ore pentru a reflecta modificările.',
  },
  error_messages: {
    invalid_phone_number: 'Număr de telefon invalid',
    saving_unsuccessful: 'Eroare la salvarea modificărilor. Vă rugăm să încercați din nou.',
    enter_correct_email: 'Vă rugăm să introduceți o adresă de email corectă.',
  },
};
